import React, { useState } from 'react';

import { ViewFieldCard, ViewFieldCardSmall, HorizontalFieldCard, HorizontalSmallFieldCard, HorizontalFieldCardTiny, VerticalFieldCard } from './ViewFieldCard';
import FieldCard from './FieldCard';
import { getExamExpiry, getExamValue } from "./ExamTools";

import {
  Card,
  Input,
  IconButton,
  Button,
  Tooltip,
  List,
  ListItem,
  ListItemPrefix,
  ListItemSuffix,

} from "@material-tailwind/react";
import {
  MapIcon,
  MagnifyingGlassIcon,
  PencilSquareIcon,
  UserPlusIcon,
  FolderOpenIcon,
  FolderMinusIcon,
} from "@heroicons/react/24/outline";


import * as turf from '@turf/turf';
import { getFields, getFieldsInfo, listStorageItems } from './AdminTools';

export default function FieldsList(props) {
  const [fields, setFields] = useState(JSON.parse(localStorage.getItem("fields") || []));
  const [clients, setClients] = useState(JSON.parse(localStorage.getItem("clients")) || []);
  const [croplist] = useState(JSON.parse(localStorage.getItem("crops")) || []);
  const [fieldid, setFieldId] = useState(0);
  const [owner, setOwner] = useState(props.clientid);
  const [search, setSearch] = useState('');
  const [authenticated, setAuthenticated] = useState(localStorage.getItem("authenticated") || false);
  const [session, setSession] = useState(localStorage.getItem("session") || null);
  const [failed, setFailed] = useState(false);
  const [message, setMessage] = useState('');
  const [showFieldCard, setShowFieldCard] = useState(false);

  const [hidden, setHidden] = useState('');

  React.useEffect(() => {
    //listStorageItems();
    //getFields(session,setFields, props.clientid); //pobierz listę pól
    

    getFields(session,setFields, props.clientid); //pobierz listę informacji o polach
    if (clients.length == 0) {
      getClients();
    }
  }, []);




  /*  
  function getFields() {
    var bodydata;
    console.log('get fields of owner ' + props.clientid);
    bodydata = JSON.stringify({ action: 'list', session: session, owner: props.clientid });
    console.log(bodydata);
    fetch('https://online.mysoil.pl/cgi-bin/fields.py', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: bodydata,
      mode: 'cors'

    })
      .then(res => res.json())
      .then(data => {
        console.log(data);
        setFields(data.fields);
        if (data.fields) {
          localStorage.removeItem("fields");
          //localStorage.setItem("fields", JSON.stringify(data.fields));
        }
      }) // może jednak ZDECYDOWANIE NIE DAWAĆ do local storage
  }
  */


  function getClients() {
    var bodydata = JSON.stringify({ action: 'clients', session: session });
    console.log(bodydata);
    fetch('https://online.mysoil.pl/cgi-bin/user.py', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: bodydata,
      mode: 'cors'

    })
      .then(res => res.json())
      .then(data => { console.log(data); setClients(data.clients); localStorage.setItem("clients", JSON.stringify(data.clients)); })
  }



  const handleShowFieldCard = (e) => {
    const id = e.currentTarget.getAttribute("data-fieldid");
    setFieldId(id);
    const owner = e.currentTarget.getAttribute("data-ownerid");
    setOwner(owner);
    setHidden('hidden');
    setShowFieldCard(showFieldCard === true ? false : true);
  };



  function FieldItem(props) {
    return (
      <div className="flex items-center justify-between gap-1 w-auto my-1">
        <div>
          <Button size="sm" variant='text' className='w-[14rem] text-left text-slate-800 normal-case'>{props.name}</Button>
          <Tooltip content="Edytuj dane pola">
            <IconButton size="sm" variant='text' className='' color="blue-gray" data-fieldid={props.id} onClick={handleShowFieldCard}>
              <PencilSquareIcon className='w-6 h-6' />
            </IconButton>
          </Tooltip>
          <Tooltip content="Pokaż pole na mapie">
            <IconButton size="sm" variant='text' className='' color="blue-gray" >
              <MapIcon className='w-6 h-6' />
            </IconButton>
          </Tooltip>
        </div>
      </div>
    )
  }

  function resizeBoundingBox(bounds) {
    var point1 = turf.point([bounds[0], bounds[1]]);
    var point2 = turf.point([bounds[2], bounds[3]]);
    var bearing = turf.bearing(point1, point2);
    var distance = turf.distance(point1, point2);
    var p1 = turf.destination(point1, -0.2 * distance, bearing);
    var p2 = turf.destination(point2, 0.2 * distance, bearing);
    var box = [p1.geometry.coordinates[0], p1.geometry.coordinates[1], p2.geometry.coordinates[0], p2.geometry.coordinates[1]];
    return box;
  }


  function applyFeatureCollection(collection) {
    try
    {
    localStorage.setItem('featureCollection', JSON.stringify(collection));
    }
    catch (err) {
    console.error(err);
    }

    dispatchEvent(new Event("featureCollectionChanged"));
  }


  function applyBoundingBox(bounds) {
    localStorage.setItem('boundingBox', JSON.stringify(bounds));
    dispatchEvent(new CustomEvent('boundingBoxChanged', { detail: bounds })); //cool can pass arguments in event this way
  }



    /**************************************
    function buildFeatureCollection(fields) {
      let newfc = {
          type: "FeatureCollection",
          features: []
        }
      console.log("Build FC");
        
        fields.forEach(field => {
          let fieldshape=JSON.parse(field.shape);
          if (field.selected==true) {
          fieldshape.features.forEach(feature => {
            feature.properties.value=1; 
            feature.fieldid=field.id; 
            newfc.features.push(feature);
          });
          }
      });
  
      if (newfc.features.length==0) 
      {
          fields.forEach(field => {
              let fieldshape=JSON.parse(field.shape);
              fieldshape.features.forEach(feature => {
                feature.properties.value=1;  
                feature.fieldid=field.id; 
                newfc.features.push(feature);
              });
              }
          );
      }
      //setClientFieldsFC(newfc);
      showGeoJson(newfc, false);
    }
    ***********************/
  



    function buildFeatureCollection(fields) {
    let newfc = {
      type: "FeatureCollection",
      features: []
    }

    console.log("build FC in client list")  ;
    fields.forEach(field => {
      let fieldshape = JSON.parse(field.shape);
      if (field.selected == true) {
        fieldshape.features.forEach(feature => {
          //feature.properties.value=1;  
          feature.properties.fieldid = field.id;
          feature.properties.value = getExamValue(feature.examtime); //feature.examined
          feature.properties.polygonName=getExamExpiry(feature.examtime); //feature.examined
          newfc.features.push(feature);
        });
      }
    });

    //console.log("newfc.feat.len " + newfc.features.length);
    if (newfc.features.length == 0) {
      fields.forEach(field => {
        let fieldshape = JSON.parse(field.shape);
        fieldshape.features.forEach(feature => {
          feature.properties.fieldid = field.id;
          feature.properties.value = getExamValue(feature.examtime); //feature.examined
          feature.properties.polygonName=getExamExpiry(feature.examtime); //feature.examined
          newfc.features.push(feature);
        });
      }
      );
    }
    //setClientFieldsFC(newfc);
    showGeoJson(newfc, true);
  }



    function showGeoJson(feature, refresh) {
      if (!feature) return;
  
      let collection;
      try {
        if (feature.type == "FeatureCollection") {
          collection = feature;
        }
        else if (feature.type == "Feature") {
          collection = {
            "type": "FeatureCollection",
            features: [feature]
          }
        }
      } catch { console.log('unknown feature type'); }
  
      if (collection.features.length == 0) {
        console.log('No features to display');
        return;
      }
  
      //console.log('Featrue Collection ready to display');
      //console.log(collection);
      //setFeaturesCount(collection.features.length);
      //set value based on examined.timestamp
  
  
  
      //console.log('Featrue Collection with colors');
      //console.log(collection);
  
      let area = turf.area(feature) / 10000.0;
      let bounds = turf.bbox(feature);
      let center = turf.center(feature);
      let resizedbounds = resizeBoundingBox(bounds);
  
      //grid(resizedbounds, collection);
      //gridtest(resizedbounds, collection);
  
      applyFeatureCollection(collection);
      applyBoundingBox(resizedbounds);
  
    }
  


  //callback from field card
  function cardCallback(refresh) {
    setShowFieldCard();
    setHidden('');
    console.log('Refresh ?');
    console.log(refresh);
    if (refresh == true) 
      {
        getFields(session, buildFeatureCollection, props.clientid);
        //getFields(session,setFields, props.clientid); //pobierz listę informacji o polach
      }
  }



  function RenderFieldsList() {
    var select = [];
    var lsearch = search.toLowerCase();
    if (!fields) return;
    if (search.length == 0 || search == '') { select = fields; }
    else if (search.length == 1) { select = fields.filter(c => c.name.toLowerCase().startsWith(lsearch)); }
    else { select = fields.filter(c => c.name.toLowerCase().includes(lsearch)); }
    /*
    console.log('fields');
    console.log(fields);
    console.log('select');
    console.log(select);
    */
    return (
      select.map(({ id, owner, image, name, area, crops, tested }) => {
        let ownername = "klient usunięty";
        if (owner==0) ownername = "nie wybrano klienta";
        try {
          let clientarray = clients.filter(c => c.id == owner);
          if (clientarray.length == 1)
            ownername = clientarray[0].name;
        }
        catch { };
        
        var cr=Number(crops);
        var crop="";
        if (cr)
                {
                var croparr=croplist.filter(c=>c.id==cr);
                    if (croparr.length>0) crop=croparr[0].cropname;
                }
        else crop="- - -";                
        
        var testDate;
        if (tested) 
          {
            var parsed=JSON.parse(tested);
            testDate = new Date(parsed.startDate); 
          } 



        return (
          <ListItem key={id} className='p-0.5 m-0' data-fieldid={id} data-ownerid={owner} onClick={handleShowFieldCard}>
            {/*<HorizontalFieldCard img={image} name={name} area={area} crops={crops} ownername={ownername} /> */}
            <HorizontalFieldCard id={id} img={image} name={name} area={area} crop={crop} owner={owner} ownername={ownername} tested={testDate}/>
            {/*<HorizontalFieldCardTiny id={id} img={image} name={name} area={area} crops={crops} owner={owner} ownername={ownername} />*/}
            

          </ListItem>

        )
      }
      )
    )
  }




  return (
    <>
      <Card className={`absolute h-[calc(100vh-2rem)] w-full max-w-[20rem] top-[1rem] p-4 shadow-xl lg:left-[17rem] left-[6rem] z-10 overflow-y-auto overflow-x-hidden ${hidden}`} >
        <div className="mb-2 p-2 flex mx-auto">
          <Input label="Szukaj" onChange={e => setSearch(e.target.value)} />
          <MagnifyingGlassIcon className='relative right-7 top-2 h-6 w-6 text-blue-500' />

          <Tooltip content="Dodaj pole">
            <IconButton size="md" variant="gradient" className='px-4' color="green" data-fieldid={0} onClick={handleShowFieldCard} >
              <MapIcon className='w-5 h-5' color="white" strokeWidth={2} />
            </IconButton>
          </Tooltip>
        </div>
        <List className='p-0 mx-0 gap-0'>
          <RenderFieldsList />
        </List>
      </Card>
      {showFieldCard === true ? <FieldCard close={cardCallback} fieldid={fieldid} clientid={owner} fields={fields} /> : ''}
    </>
  );
}

